var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'common-tab text-decoration-none',
    _vm.renderActiveClassName,
    _vm.customClassName ? _vm.customClassName : ''
  ],on:{"click":function($event){return _vm.$emit('handleClick', _vm.label)}}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }